export const SET_STATIC_NEWS = 'news/SET_STATIC_NEWS';

export const setStaticNews = (staticNews) => ({
    type: SET_STATIC_NEWS,
    payload: {
        staticNews,
    },
});
